module.exports = __webpack_public_path__ + "static/img/8-6.85ec0aca.jpg";